import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "success-header text-center" }

export function render(_ctx, _cache) {
  const _component_fa_icon = _resolveComponent("fa-icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_fa_icon, { icon: ['far', 'check-circle'] }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "header")
      ]),
      _: 3
    })
  ]))
}